<template>
  <div class="rounded divide-y divide-bg">
    <div class="flex p-2"
         v-for="i in 5" :key="i">
      <LoaderBlock class="h-4-5 w-5 mr-2"/>
      <LoaderBlock class="h-4-5 flex-1 mr-4"/>
      <LoaderBlock class="h-4-5 flex-1"/>
    </div>
  </div>
</template>

<script>
import LoaderBlock from "@/components/UI/LoaderBlock";

export default {
  name: "MyAccountsLoadingRows",
  components: {LoaderBlock},
}
</script>

<style scoped>

</style>